import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Stack, MenuItem } from "@mui/material";
import { PhysicianType } from '../../../../services/ConfigurationService/types/physicianType';
import { useUpdatePhysicianMutation, useGetSpecialtiesQuery } from '../../../../services/ConfigurationService';
import { useLocation } from 'react-router-dom';

interface EditPhysicianDialogProps {
  physician: PhysicianType;
  trigger: React.ReactNode;
}

export function EditPhysicianDialog({ physician, trigger }: EditPhysicianDialogProps) {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const companyFromUrl = query.get('company') || physician.company || '';
  const { data: specialties, isLoading: specialtiesLoading } = useGetSpecialtiesQuery();
  const [updatePhysician] = useUpdatePhysicianMutation();
  const [open, setOpen] = React.useState(false);
  const [form, setForm] = React.useState<PhysicianType>({ ...physician, company: companyFromUrl });

  React.useEffect(() => {
    setForm({ ...physician, company: companyFromUrl });
  }, [physician, companyFromUrl]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value, company: companyFromUrl }));
  };

  const handleSave = async () => {
    // Set id as centerId-code before saving
    const newForm = {
      ...form,
      id: `${form.centerId}-${form.code}`,
      company: companyFromUrl,
    };
    await updatePhysician(newForm);
    setOpen(false);
  };

  return (
    <>
      <span onClick={() => setOpen(true)} style={{ cursor: 'pointer' }}>{trigger}</span>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Physician</DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <TextField label="First Name" name="firstName" value={form.firstName} onChange={handleChange} fullWidth required />
            <TextField label="Last Name" name="lastName" value={form.lastName} onChange={handleChange} fullWidth required />
            <TextField
              label="Specialty"
              name="specialtyValue"
              value={form.specialtyValue}
              onChange={handleChange}
              fullWidth
              required
              select
              disabled={specialtiesLoading}
            >
              {(specialties || []).map(opt => (
                <MenuItem key={opt.value} value={opt.value}>{opt.name}</MenuItem>
              ))}
            </TextField>
            <TextField label="NPI" name="npi" value={form.npi} onChange={handleChange} fullWidth />
            <TextField label="Phone" name="phone" value={form.phone} onChange={handleChange} fullWidth />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained">Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}


